import { Vertical } from '@dashboard/shared-ui/utils/vertical-configs';
export function getVerticalColor(vertical) {
  switch (vertical) {
    case Vertical.RESTAURANTS:
    case Vertical.RESTAURANTS_PRO:
      return '#f75a38';
    case Vertical.RETAIL:
      return '#00c1ae';
    default:
      return '#b3b3b3';
  }
}